import { render, staticRenderFns } from "./ShipFromDialog.vue?vue&type=template&id=28ff2544&"
import script from "./ShipFromDialog.vue?vue&type=script&lang=js&"
export * from "./ShipFromDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports